export default "__VITE_ASSET__a440e4ca__"